// Interfaces
import { EditorState, Transaction } from "../interfaces";
import { splitBracketBlock, splitTextOutsideBrackets } from "@/Motivators/helpers/specialUnits/InventorySearch/textPositionHelpers";
import { KEYWORD_CONTEXT, ReservedWord } from "../utils";
import { escapeForRegEx } from "@tiptap/core";

function getPredictiveWordMatchAndOffset(textPart: string, words: ReservedWord[]) {
	let endOffset = textPart.length;
	const match = words.find(({ word, context }) => {
		if (textPart.toLowerCase() === word.toLowerCase()) {
			return true;
		} else if (context === KEYWORD_CONTEXT.beforeNumber) {
			const regexp = new RegExp(`^${escapeForRegEx(word)}\\d+\\.?\\d*`, "i");
			const found = regexp.test(textPart);
			if (found) {
				endOffset = word.length;
			}
			return found;
		} else if (context === KEYWORD_CONTEXT.beforeParens) {
			const regexp = new RegExp(`^${escapeForRegEx(word)}\\(`, "i");
			const found = regexp.test(textPart);
			if (found) {
				endOffset = word.length;
			}
			return found;
		}
		return false;
	});
	return { match, endOffset };
}

// Function to make specific words bold
function makeWordsBold(state: EditorState, tr: Transaction, words: ReservedWord[] = []) {
	const bracketBlocks = splitTextOutsideBrackets(state.doc.textContent);
	let totalLengthBefore = 0;
	bracketBlocks.forEach((block) => {
		if (words.find(({ word, context }) => context === "alone" && word.toLocaleLowerCase() === block.toLowerCase())) {
			// the whole block is a reserved word
			const start = totalLengthBefore + 1;
			const end = start + block.length;

			tr.addMark(start, end, state.schema.marks.bold.create());
			totalLengthBefore += block.length;
			return;
		}

		const { valuesIndex, valuesPart } = splitBracketBlock(block);
		let overallIndex = totalLengthBefore + valuesIndex;

		const parts = valuesPart.split(/("[^"]*"?)|(\s+)/g).filter(Boolean);
		parts.forEach((part) => {
			const { match, endOffset } = getPredictiveWordMatchAndOffset(part, words);

			if (match) {
				const start = overallIndex + 1;
				const end = start + endOffset;
				tr.addMark(start, end, state.schema.marks.bold.create());
			}
			overallIndex += part.length;
		});

		totalLengthBefore += block.length;
	});
}

function unsetWordsBold(state: EditorState, tr: Transaction) {
	tr.removeMark(1, state.doc.textContent.length + 1, state.schema.marks.bold);
}

export { makeWordsBold, unsetWordsBold };
